export default __webpack_public_path__ + "static/media/h4x.bb901a11.png";